import React, { Component } from "react";
import { app } from "../stitch";
import { Link } from "react-router-dom";
import { ModalContext } from "../App.js";

export default class PasswordResetter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      resetSuccess: false,
      isResetting: false,
    };
  }
  onInputChange = (event) => {
    this.setState({ password: event.target.value });
  };

  componentDidMount() {
    const url = window.location.search;
    const params = new URLSearchParams(url);
    const token = params.get("token");
    const tokenId = params.get("tokenId");
    this.setState({ token: token, tokenId: tokenId });
  }

  onPasswordReset = () => {
    if (this.state.isResetting) {
      return;
    }
    this.setState({ isResetting: true });

    app.emailPasswordAuth
      .resetPassword(this.state.token, this.state.tokenId, this.state.password)
      .then(() => {
        this.setState({ resetSuccess: true, isResetting: false });
      })
      .catch((err) => {
        if (err.message === "invalid token data") {
          this.setState({
            error:
              "invalid token data, this could mean that the link has expired",
          });
        } else {
          this.setState({ error: err.message, isResetting: false });
        }
      });
  };

  render() {
    return (
      <div>
        {!this.state.resetSuccess ? (
          <div>
            {this.state.error ? this.state.error : null}
            <div>Enter your new password:</div>
            <div>
              <input
                style={{ border: "1px solid black" }}
                onChange={this.onInputChange}
                value={this.state.password}
              />
            </div>
            <div>
              <button onClick={this.onPasswordReset}>submit</button>
            </div>
          </div>
        ) : null}

        {this.state.resetSuccess ? (
          <ModalContext.Consumer>
            {({ isModalShowing, toggleModal }) => (
              <Link
                to="/"
                onClick={() => {
                  toggleModal();
                }}
              >
                Reset success, go to login screen
              </Link>
            )}
          </ModalContext.Consumer>
        ) : null}
      </div>
    );
  }
}
